import { render, staticRenderFns } from "./onlineDataWater1.vue?vue&type=template&id=65814591&scoped=true&"
import script from "./onlineDataWater1.vue?vue&type=script&lang=js&"
export * from "./onlineDataWater1.vue?vue&type=script&lang=js&"
import style0 from "./onlineDataWater1.vue?vue&type=style&index=0&id=65814591&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65814591",
  null
  
)

export default component.exports